import { KeyRound } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DemoBanner } from "@/components/layout/DemoBanner"
import { useAuth } from "@/features/auth/hooks/useAuth"
import { useAuthStore } from "@/store/auth.store"
import { ChangePasswordForm } from "./ChangePasswordForm"

/**
 * Shown instead of the application while the account's password was set by an
 * administrator. The API refuses every other request until it is changed.
 */
export function ForcedPasswordChange() {
  const me = useAuthStore((s) => s.me)
  const { logout, isLoggingOut } = useAuth()
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <DemoBanner />
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-sm space-y-6">
          <div className="space-y-2">
            <KeyRound className="h-8 w-8 text-primary" aria-hidden />
            <h1 className="text-2xl font-bold text-foreground">Choose your own password</h1>
            <p className="text-sm text-muted-foreground">
              {me ? <><strong className="text-foreground">{me.user.username}</strong>, your</> : "Your"} password was set by the
              administrator. Replace it with one only you know before continuing.
            </p>
          </div>
          <ChangePasswordForm submitLabel="Save and continue" />
          <Button variant="ghost" className="w-full" onClick={logout} disabled={isLoggingOut}>Sign out</Button>
        </div>
      </div>
    </div>
  )
}
